<template>
  <div class="flex flex-row">
    <div class="pt-4 basis-half">
      <p>
        <!-- Checkbox for toggling -->
        <input type="checkbox" v-model="showAbsent" @change="toggleAbsent">
        Mostrar repartidores ausentes
      </p>
      <div class="deliverymen">
        <div class="deliveryman" v-for="deliveryman in computedDeliverymen" :key="deliveryman.uuid">
          <el-card class="box-card">
            <div slot="header" style="width: 100%;">
              <div style="display: inline-block;">
                <span>{{ deliveryman.name }}</span>
                <!-- Adds a dot for active -->
                <span :style="{ 'background-color': deliveryman.color }" class="active-dot"></span>
              </div>
              <!-- Displays the received payments-->
              <div style="float: right; display: inline-block;">
                <div style="display: inline; margin-right: 1rem;" v-for="(payment, method) in deliveryman.payments"
                  :key="payment">
                  <span style="border: 1px solid #c3c3c3; border-radius: 0.2rem; padding: 0.3rem;">
                    <i class="el-icon-money text-success" v-if="method == 'cash'"></i>
                    <i class="el-icon-bank-card text-primary" v-else></i>
                    <span class="monospace" v-for="(amount, currency) in payment" :key="amount">
                      ${{ Intl.NumberFormat('es-MX').format(amount) }}<span class="text-secondary">{{ currency }}</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="tickets">
              <div :class="order.current_status" v-for="order in deliveryman.orders" :key="order.uuid">
                <el-button size="small" plain @click="showTicket(order)" @mouseover.native="showOrderPin(order)"
                  @mouseleave.native="hideOrderPin(order)">
                  {{ order.ticket_number }}
                </el-button>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <div class="deliverymen_map">
      <l-map style="height: 850px; width: 100%" :zoom="map.zoom" :center="map.center" @update:center="centerUpdate"
        @update:zoom="zoomUpdate">
        <l-tile-layer :url="map.url" />
        <l-marker v-for="(marker, index) in map.markers" :key="index" :icon="getIcon(marker)" :lat-lng="marker.pos">
          <l-tooltip :content="marker.popup" :options="marker.options"> </l-tooltip>
        </l-marker>
        <l-polyline :lat-lngs="map.polyline.latlngs" :color="map.polyline.color" />
      </l-map>
    </div>

    <ticketInfo :showInfoDialog="showInfoDialog" :dialogData="dialogData" :dialogTitle="dialogTitle" ref="ticketInfo"
      v-on:close="closeDialog()" />

  </div>
</template>

<script>
import { getDeliverymen, assignDeliveryman, getDeliverymenLocation} from "@/api/deliverymen.js"
import { getStores } from "@/api/stores.js"
import { LMap, LTileLayer, LMarker, LTooltip, LPolyline } from 'vue2-leaflet';
import ticketInfo from "@/views/components/Dialogs/ticketInfo.vue"
import { time, colors } from "@/utils/utils.js"

export default {
  name: "Deliverymen",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPolyline,
    ticketInfo
  },
  data() {
    return {
      status: "",
      tableData: [],
      deliverymen: [],
      showAbsent: false,
      showInfoDialog: false,
      dialogTitle: "Ticket #??",
      dialogData: {
        assignedTo: "",
        statusId: 0,
        created_at: "",
        customer: {
          name: "",
          address: "",
          phone: "",
        },
        products: [],
      },
      map: {
        url: 'https://maps.fiexact.com/tile/{z}/{x}/{y}.png',
        // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        zoom: 12,
        center: [31.69, -106.44],
        markers: [],
        polyline: {
          latlngs: [],
          color: '#ff0000',
        },
      },
      options: { permanent: true },
      time: "",
      convertedTime: "",
      stores: [],
    };
  },
  mounted() {
    window.setInterval(() => {
      this.getDeliverymen();
    }, 50000);
  },
  created() {
    this.map.center = [31.69, -106.44];
    this.getStores();
    this.getDeliverymen();
    this.getSectorMap(); 
  },
  computed: {
    computedDeliverymen() {
      // Remove the deliverymen that were not active in the last XX minutes
      return this.deliverymen.filter(deliveryman =>
        (this.showAbsent || time.isAfter(deliveryman.last_login, 120))
      ).map(deliveryman => {
        // Adds a unique color from the name of the deliveryman
        let hash = 0;
        for (let i = 0; i < deliveryman.name.length; i++) {
          hash = deliveryman.name.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#' + (hash & 0x00FFFFFF).toString(16);

        this.map.markers = this.map.markers.filter(marker => {
          return marker.type != "deliveryman"
        });
        getDeliverymenLocation(deliveryman.uuid) 
          .then(deliveryLocation => {
            this.updateDeliverymenMarkers(deliveryLocation,deliveryman );
          })
          .catch(error => {
            console.log(error);
          });

        return {
          ...deliveryman,
          color: colors.getColor(deliveryman.name),
        }
      });
    },
  },

  methods: {
    toggleAbsent() {
      // this.updateDeliverymenMarkers();
    },

    getDeliverymen() {
      getDeliverymen()
        .then(deliverymen => {
          this.deliverymen = deliverymen;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getSectorMap(){
      sectorMapDivision(map);
    },

    updateDeliverymenMarkers(deliveryLocation,delivery) {
      if(deliveryLocation.deliveryman_uuid == delivery.uuid) {
        if (deliveryLocation.location != null && delivery.location != null) {
          this.time = new Date(deliveryLocation.created_at);
          this.convertedTime = this.time.toTimeString().split(" ")[0];
          this.map.markers.push({
            pos: [deliveryLocation.location.latitude, deliveryLocation.location.longitude],
            popup: delivery.name + " <br/> " + this.convertedTime,
            type: "deliveryman",
            options: { permanent: false, zIndexOffset: 1000 },
            color: colors.getColor(delivery.name)
          });
        }
      };
    },

    getStores() {
      getStores()
        .then(stores => {
          this.stores = stores;
          this.stores.forEach(store => {
            this.map.markers.push({
              pos: [store.gps_latitud, store.gps_longitud],
              popup: store.nombre + " <br/> " + "Ext. " + store.extension,
              type: "store",
              color: "#00837A",
              options: { permanent: false, zIndexOffset: 0 },
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    showTicket(order) {
      this.showInfoDialog = true;
      this.dialogData = order;
      this.dialogTitle = "Ticket #" + order.ticket_number;

      this.dialogData.items.forEach((item) => {
        item.unit_price_formatted = "$" + item.unit_price.toFixed(2);
        item.total = "$" + (item.unit_price * item.units).toFixed(2);
      });

      this.$refs.ticketInfo.mapInfo(order);

    },

    showOrderPin: function (order) {
      // this.map.markers.push({
      //   pos: [order.customer_location.latitude, order.customer_location.longitude],
      //   popup: `Orden #${order.ticket_number}`,
      //   type: "order",
      //   color: "#40b4e5",
      //   options: { permanent: false },
      // });

      if(order.customer.location.coordinates.length > 0) {
        this.map.markers.push( { 
          pos: order.customer.location.coordinates,
          text: "Dirección de entrega",
          color: "#40b4e5",
          type: "order"
        });
        console.log("modal map", this.map);
      }

      order.items.forEach((item) => {
        if (item.recolections.length > 0) {
          item.recolections.forEach((recolection) => {
            this.map.markers.push( { 
              pos: [ recolection.location.coordinates[0], recolection.location.coordinates[1] ],
              text: `Recogido(s) ${recolection.units} ${item.name}`,
              color: "#e54062",
              type: "order"
            });
          });
        }
      });

      if(order.current_status == "delivered" ){
        let temp = order.delivery.location;
        this.map.markers.push({
          pos:  [temp.coordinates[0], temp.coordinates[1]],
          color: "#b4e540",
          text: "Lugar de entrega",
          type: "order"
        });
      }
    },

    hideOrderPin(order) {
      this.map.markers = this.map.markers.filter(marker => {
        return marker.type != "order"
      });
    },

    zoomUpdate(zoom) {
      this.map.zoom = zoom;
    },
    centerUpdate(center) {
      this.map.center = center;
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'total' || column.property == 'unit_price_formatted') {
        return {
          fontFamily: 'IBM Plex Mono Bold',
          fontSize: '16px',
          color: '#465656'
        };
      } else {
        return {
          fontFamily: 'trebuc',
          fontSize: '15px',
          color: '#465656'
        };
      }
    },

    getIcon(item) {
      item.strokeColor = item.color;
      item.circleColor = '#FFFFFF';

      if(item.type == 'deliveryman'){
        return L.divIcon({
          className: "my-pin-delivery",
          html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34.892337" height="65" width="60" color="#000">
            <title>motorbike</title>
            <path d="M17.42,10L13.41,6H9V8H12.59L14.59,10H6.5C4,10 2,12 2,14.5C2,17 4,19 6.5,19C8.72,19 10.56,17.38 10.92,15.27L13.04,14C13,14.17 13,14.33 13,14.5C13,17 15,19 17.5,19C20,19 22,17 22,14.5C22,12 20,10 17.5,10M8.84,15.26C8.5,16.27 7.58,17 6.47,17C5.09,17 3.97,15.88 3.97,14.5C3.97,13.12 5.09,12 6.47,12C7.59,12 8.5,12.74 8.84,13.75H6V15.25L8.84,15.26M17.47,17C16.09,17 14.97,15.88 14.97,14.5C14.97,13.12 16.09,12 17.47,12A2.5,2.5 0 0,1 19.97,14.5A2.5,2.5 0 0,1 17.47,17Z" style="fill:${item.color};stroke:${item.strokeColor};" />
            </svg>`
        });}

      if(item.text == "Dirección de entrega"){
        return L.divIcon({
        className: "my-pin-delivered",
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 34.892337" height="55" width="50">
          <title>home</title>
          <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" style="fill:${item.color};stroke:${item.strokeColor};"/>
          </svg>`
        })}
      
      return L.divIcon({
        className: "my-custom-pin",
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34.892337" height="45" width="40">
        <g transform="translate(-814.59595,-274.38623)">
          <g transform="matrix(1.1855854,0,0,1.1855854,-151.17715,-57.3976)">
            <path d="m 817.11249,282.97118 c -1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867 0.0639,3.84476 1.79693,5.3002 4.56836,10.59179 0.99832,2.32851 2.04027,4.79237 3.03125,8.87305 0.13772,0.60193 0.27203,1.16104 0.33416,1.20948 0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455 0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109 2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918 0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062 -1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655 -2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162 z" style="fill:${item.color};stroke:${item.strokeColor};"/>
            <circle r="3.0355" cy="288.25278" cx="823.03064" id="path3049" style="display:inline;fill:${item.circleColor};"/>
          </g>
        </g>
        </svg>`
      });   
    },

    showMessage(msg, type) {
      this.$message({
        timeout: 50000,
        message: msg,
        type: type,
      });
    },

    isObjectEmpty(obj) {
      return !(Object.keys(obj).length)
    },

    closeDialog() {
      this.showInfoDialog = false;
    },

  },

}

</script>

<style scoped>
.flex {
  display: flex;
  flex-direction: row;
}

.deliverymen {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  grid-gap: 20px;
  padding-top: 30px;
  margin-left: 25px;
}

.box-card {
  margin: 5px;
  min-width: 450px;
  height: 100%;
}

.active-dot {
  background-color: red;
  content: '';
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 10px;
}

.tickets {
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap; */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
}

.deliverymen_map {
  width: 50%;
  padding: 30px;
  margin: 5px;
  position: sticky;
}

.basis-half {
  flex: 1 1 50%;
}

.assigned .el-button,
.collecting .el-button,
.collected .el-button,
.delivered .el-button,
.cancelled .el-button {
  font-family: 'trebuc';
  font-size: 15px;
  width: 90%;
  height: 33px;
  margin: 6px;
}

.assigned .el-button {
  background-color: #409EFF;
  border-color: #409EFF;
  color: #FFFFFF;
}

.assigned .el-button:hover,
.assigned .el-button:focus {
  background-color: #54A8FF;
  border-color: #54A8FF;
  color: #FFFFFF;
}

.collecting .el-button {
  background-color: #FB8C00;
  border-color: #FB8C00;
  color: #FFFFFF;
}

.collecting .el-button:hover,
.collecting .el-button:focus {
  background-color: #FF9816;
  border-color: #FF9816;
  color: #FFFFFF;
}

.collected .el-button {
  background-color: #FFEB3B;
  border-color: #FFEB3B;
  color: #000000;
}

.collected .el-button:hover,
.collected .el-button:focus {
  background-color: #FFEE55;
  border-color: #FFEE55;
  color: #000000;
}

.delivered .el-button {
  background-color: #67C23A;
  border-color: #67C23A;
  color: #FFFFFF;
}

.delivered .el-button:hover,
.delivered .el-button:focus {
  background-color: #76C94C;
  border-color: #76C94C;
  color: #FFFFFF;
}

.cancelled .el-button {
  background-color: #9E9E9E;
  border-color: #9E9E9E;
  color: #FFFFFF;
}

.cancelled .el-button:hover,
.cancelled .el-button:focus {
  background-color: #B8B8B8;
  border-color: #9E9E9E;
  color: #FFFFFF;
}
</style>
